<template>
  <basic-dialog v-model="dialog" :action-buttons="actionButtons"
                :persistent="false"
                color="info"
                :title="$t('tasks.task_vote')">
    <v-card-text class="text-body-2 text-md-body-1 pt-10 pb-8">
      <v-row>
        <v-col cols="12" sm="7">
          <p>{{ $t('tasks.task_vote_help') }}</p>
          <p>{{ $t('tasks.task_vote_help2') }}</p>
        </v-col>
        <v-col cols="12" sm="5" class="text-center">
          <span style="display: inline-block;" :style="{width: $vuetify.breakpoint.xsOnly ? '70%' : '100%'}" >
            <v-img src="/img/undraw_upvote_re_qn2k.svg" />
          </span>
        </v-col>
      </v-row>
    </v-card-text>
  </basic-dialog>
</template>

<script>
import BasicDialog from "@/components/BasicDialog";
export default {
  name: "TaskVoteHelpDialog",
  components: {BasicDialog},
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    open() {
      this.dialog = true;
    }
  },
  computed: {
    actionButtons() {
      return {
        close: {
          click: () => this.dialog = false,
        },
      }
    },
  }
}
</script>

<style scoped>

</style>
